import { View } from 'react-native';
import { MealFormDialog } from '~/meal/components/meal-form-dialog/MealFormDialog';

export default function PreviewMeal() {
  return (
    <View style={{ flex: 1 }}>
      <MealFormDialog onClose={() => {}} />
    </View>
  );
}
